import * as events from "events";

import { Injectable } from "@angular/core";

import { AccountService } from "./account.service";
import { ProductService } from "./product.service";
import { EnergystorageService } from "./energystorage.service";
import { SmartPanelService } from "./smart-panel.service";
import { Domain as WebsideDomain } from "../../../lib/Domain/Webside";


@Injectable()
export class HttpService extends events.EventEmitter {
  public userinfo: WebsideDomain.IAccount | null = null;
  public typeslists: any[] = [];


  constructor(public account: AccountService,
    public product: ProductService,
    public energystorageService: EnergystorageService,
    public smartPanelService: SmartPanelService
  ) {
    super();
    this.account.Loginstat().then((user) => {
      this.userinfo = user;
    }).catch(() => { this.userinfo = null; });
  }

  public async Login(email: string, password: string, rememberMe: boolean): Promise<WebsideDomain.IAccount> {
    this.userinfo = await this.account.Login(email, password, rememberMe);
    return this.userinfo;
  }
  public async Logout(): Promise<void> {
    await this.account.Logout();
    this.userinfo = null;
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/http.service.ts